import CommonHeading from "../../../../Components/CommonHeading";
import Selector from "./Select";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import DateSection from "./DateSection";
import ExportExcel from "../../../../Components/ExportExcel";
import { Link } from "react-router-dom";
import InfoModule from "../../../../Components/InfoModule";
import { useMemo } from "react";
import { useExcludedStudentsStore } from "../../../../Store/ReportsStore/ExcludedStudentsStore";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const {
    loadItems,
    updateParams,
    staffs_list,
    reasons,
    branches,
    queryParams,
    setLoading,
    students_count,
  } = useExcludedStudentsStore();

  const { t } = useTranslation();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search_query: payload.term, page: 1 });
    setLoading(true);
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search_query: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const initialValues = {
    term: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const user = JSON.parse(localStorage.getItem("token"));

  const queryString = new URLSearchParams({
    ...queryParams,
    download: "excel",
    token: user.access || "",
  }).toString();

  const optionsReason = useMemo(() => {
    return (
      reasons?.map((element) => ({
        label: element.name,
        value: element.value,
      })) || []
    );
  }, [reasons]);

  const optionsBranch = useMemo(() => {
    return (
      branches?.map((element) => ({
        label: element.title,
        value: element.id,
      })) || []
    );
  }, [branches]);

  const optionsStaff = useMemo(() => {
    return (
      staffs_list?.map((element) => ({
        label: element.fullname,
        value: element.id,
      })) || []
    );
  }, [staffs_list]);

  return (
    <CommonHeading
      topItems={
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,160px) 200px 50px",
            gap: "10px",
          }}
        >
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={optionsBranch} property={t("Filiallar")} />
          <Selector options={optionsStaff} property={t("O'qituvchilar")} />
          <Selector options={optionsReason} property={t("Status")} />
          <DateSection />
          <InfoModule title={students_count} />
        </div>
      }
      rightItems={
        <Link
          to={
            `https://admin.smartportal.uz/api/reports/excluded-students/?` +
            queryString
          }
          download
          target={"_blank"}
        >
          <ExportExcel />
        </Link>
      }
      tableHead={<TableHead />}
    />
  );
}
